import React from 'react';
import { LogOut, LayoutDashboard, ArrowLeft } from 'lucide-react';
import cipherLogo from '../../assets/cipher-icon-only-transparent.png';
import { colors } from '../../theme';

const theme = {
  bg: colors.bg,
  bgCard: colors.surface1,
  border: colors.borderStrong,
  gold: colors.gold,
  text: colors.text,
  muted: colors.textMuted,
  danger: colors.danger,
};

/**
 * Shared top-bar header for all Cipher pages.
 *
 * Props:
 *  - title       : string  — page title shown next to the logo
 *  - subtitle    : string  — optional small text below the title
 *  - onBack      : fn      — renders a "← Back" button when provided
 *  - backLabel   : string  — override back button label (default "Back")
 *  - onDashboard : fn      — renders a "Dashboard" button when provided
 *  - onLogout    : fn      — renders a "Logout" button when provided
 */
const CipherHeader = ({ title, subtitle, onBack, backLabel = 'Back', onDashboard, onLogout }) => (
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    paddingBottom: '16px',
    borderBottom: `1px solid ${theme.border}`,
  }}>
    {/* Left: logo + title */}
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      {onBack && (
        <button
          onClick={onBack}
          style={{
            display: 'flex', alignItems: 'center', gap: '6px',
            background: 'transparent', border: `1px solid ${theme.border}`,
            color: theme.muted, padding: '7px 12px', borderRadius: '8px',
            cursor: 'pointer', fontSize: '13px', fontWeight: 500,
            marginRight: '4px',
          }}
        >
          <ArrowLeft size={14} /> {backLabel}
        </button>
      )}
      <div style={{
        width: '36px', height: '36px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
      }}>
        <img src={cipherLogo} alt="Cipher" style={{ width: '32px', height: '32px' }} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div style={{
          color: theme.gold, fontSize: '14px', fontWeight: 700,
          letterSpacing: '2px', fontFamily: "'Orbitron', sans-serif",
          lineHeight: 1,
        }}>
          CIPHER
        </div>
        {(title || subtitle) && (
          <div style={{ color: theme.muted, fontSize: '11px', marginTop: '2px' }}>
            {title}{subtitle ? ` — ${subtitle}` : ''}
          </div>
        )}
      </div>
    </div>

    {/* Right: action buttons */}
    <div style={{ display: 'flex', gap: '10px' }}>
      {onDashboard && (
        <button onClick={onDashboard} style={{
          display: 'flex', alignItems: 'center', gap: '6px',
          background: 'transparent', border: `1px solid ${theme.gold}`,
          color: theme.gold, padding: '10px 16px', borderRadius: '8px',
          cursor: 'pointer', fontSize: '13px', fontWeight: 600,
        }}>
          <LayoutDashboard size={14} /> Dashboard
        </button>
      )}
      {onLogout && (
        <button onClick={onLogout} style={{
          display: 'flex', alignItems: 'center', gap: '6px',
          background: 'transparent', border: `1px solid ${theme.danger}`,
          color: theme.danger, padding: '10px 16px', borderRadius: '8px',
          cursor: 'pointer', fontSize: '13px', fontWeight: 600,
        }}>
          <LogOut size={14} /> Logout
        </button>
      )}
    </div>
  </div>
);

export { theme };
export default CipherHeader;
